import Peit from './peit';
import {Provider} from './language';

export default ()=><Provider><Peit/></Provider>